/* eslint-disable array-callback-return */
import React from 'react';

export default function DraftOrder(props) {
    const lastAction = props.lastAction;
    const currentPick = props.currentPick;
    const orderArray = props.draftorder;
    const players = props.players;

    const pickOrder = orderArray.map((pick)=>{
        var currentPickClass = pick.position === currentPick ? 'current-pick' : '';
        if(props.showTable) {
         // return null   
        } else if (pick.position === currentPick && lastAction === 'player_returned') {
            document.querySelector('#draft-order').scrollBy({ 
                top:0,
                left: -130,
                behavior: 'smooth'
            });
        } else if (pick.position === currentPick && currentPick > 3 && lastAction === 'player_drafted') {
            document.querySelector('#draft-order').scrollBy({ 
                top:0,
                left: 130,
                behavior: 'smooth'
            });
        } else if (lastAction === 'reset') {
            document.querySelector('#draft-order').scrollTo({ 
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
        var teamSelection = players.find(x => x.pick === pick.position);
        var name = '';
        if(typeof teamSelection !== 'undefined') {
            var fname = teamSelection.player.split(",")[1].trim();
            var lname = teamSelection.player.split(",")[0].trim();
            name = `${fname} ${lname}`
        }

        return (
            <li key={pick.position} id={'draft-order-' + pick.position} className={currentPickClass}><span className="draft-order__pick-position">{pick.position}</span><span className="draft-order__team-name">{pick.name}</span><span className="draft-order__team-selection">{name}</span></li>
        )

    })
    
    return  (
        <div id="draft-order" className="scrollbar scrollbar-x">
            <ol id="draft-list">
                {pickOrder}
            </ol>
        </div>
    )
};